// create a base axios query with auth headers
import { getAuthToken } from './authService';
import { baseURL } from './constants';
import axios from 'axios';

const axiosWithAuth = async ({contentType = 'application/json'}: any) => {
  const token = await getAuthToken();
  return axios.create({
    baseURL,
    headers: {
      'Content-Type': contentType,
      Authorization: `${token}`,
    },
  });
};

export default axiosWithAuth;

// how to use it
// import axiosBase from './axiosBase';
//  const axios = await axiosBase({contentType: 'multipart/form-data'});
//  const response = await axios.post(`/project`, formData);